import { Plugin, Editor } from "ckeditor5";
import ResponseTransformationCommand from "./responseTransformationCommand";
import { Operation } from "./responseTransformationPluginUtil";
import { operationToCommand } from "./responseTransformationPluginUtil";

export default class ResponseTransformationEditing extends Plugin {
  public init(): void {
    const editor: Editor = this.editor;
    const operations = editor.config.get("ai.operations") as Operation[];
    operations.forEach((op) => {
      const commandName = operationToCommand(op.name);
      editor.commands.add(commandName, new ResponseTransformationCommand(editor, op.name));
    });
  }

  public static get pluginName(): string {
    return "ResponseTransformationEditing";
  }
}
